import { styled } from '@mui/material';

export const Root = styled('div')(({ theme }) => ({
  maxWidth: 500,
  margin: 'auto',
}));

export const Actions = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
}));

export const LoadingContainer = styled('div')({
  maxWidth: 500,
  margin: 'auto',
});